import React from "react";
import { Link } from "react-router-dom";
import InairaHealthLogo from "@assets/images/logo.png";
import lrLogo from "@assets/images/lr-login-logo.png";
import { makeStyles } from "@mui/styles";
import { appConfig,LOGO_TYPE } from "@config/AppConfig";

const useStyles = makeStyles(MUITheme => ({
  logoContainer:{
    height:70,
    '&.mini':{
      height:40
    },
    '& img':{
      maxHeight:'100%'
    },
    '&.mb-16':{
      marginBottom:16,
    },
    '&.mb-50':{
      marginBottom:50,
    },
    '&.lr-logo':{
      backgroundColor:'var(--header_bg)',
      borderRadius:4,
      padding:'4px 0'
    }
      
  }
}));
const Logo = ({className=''}) => {
  const {headerOptions,...appCF} = appConfig().config;
  const classes = useStyles();
  return <div className={`logoCtr ${classes.logoContainer} ${className} ${appCF.logoClass}`}><Link to={"/"}><img src={appCF.mainLogo == LOGO_TYPE.LR? lrLogo:InairaHealthLogo} alt="iNaira Healthcare" /></Link></div>;
};

export default Logo;
